import type { FormField } from '../../types';

interface Props { field: FormField; value?: unknown; onChange?: (v: unknown) => void; error?: string; }

/**
 * Presentation-only field: renders the form author's prose instead of an input.
 * Blank lines start a new paragraph; single newlines are kept as line breaks by
 * `white-space: pre-line`. The text is rendered as text, never as HTML.
 */
export function ParagraphField({ field }: Props) {
  const blocks = (field.text ?? '')
    .split(/\n\s*\n/)
    .map(block => block.trim())
    .filter(Boolean);

  if (blocks.length === 0) return null;

  return (
    <div className="form-text">
      {blocks.map((block, i) => <p key={i}>{block}</p>)}
    </div>
  );
}
